import { createReduxModule } from "hooks-for-redux";
import {
  IInitialInputValues,
  IInitialProduction,
  IInputValues,
  IProductionReducerInitialState,
  IProductionValues,
} from "./ProductionReducer.types";
import productionReducerInitialState from "./ProductionReducerInitialState";
import { parseIntProductionReducerHelper } from "../../utils/helpers/parseIntProductionReducerHelper";

export const [
  useProductionReducer,
  {
    setProductionState,
    UpdateCommissionInputFieldValues,
    UpdateCommissionCheckboxValue,
    AddCommissionProduction,
    UpdateCommissionProduction,
    DeleteCommissionProduction,
    UpdatePremiumInputFieldValues,
    UpdatePremiumCheckboxValue,
    AddPremiumProduction,
    UpdatePremiumProduction,
    DeletePremiumProduction,
    UpdateIncomeInputFieldValues,
    UpdateIncomeCheckboxValue,
    AddIncomeProduction,
    UpdateIncomeProduction,
    DeleteIncomeProduction,
    UpdateCurrency,
    UpdateCommissionPoliciesCasesInputs,
    UpdateCommissionPoliciesCasesCheckbox,
    AddCommissionPoliciesCases,
    UpdateCommissionPoliciesCases,
    DeleteCommissionPoliciesCases,
    UpdatePremiumPoliciesCasesInputs,
    UpdatePremiumPoliciesCasesCheckbox,
    AddPremiumPoliciesCases,
    UpdatePremiumPoliciesCases,
    DeletePremiumPoliciesCases,
    UpdateIncomePoliciesCasesInputs,
    UpdateIncomePoliciesCasesCheckbox,
    AddIncomePoliciesCases,
    UpdateIncomePoliciesCases,
    DeleteIncomePoliciesCases,
    RemoveCompanyAddedProduction,
    RemoveUserAddedProduction,
  },
  productionReducer,
] = createReduxModule("productionReducer", productionReducerInitialState, {
  setProductionState: (state, data: IProductionReducerInitialState) => ({
    ...state,
    ...data,
  }),
  UpdateCommissionInputFieldValues: (
    state,
    inputValuesObject: IInputValues
  ) => {
    const newState: IInitialInputValues[] = [...state.commissionInputValues];

    newState[inputValuesObject.idx].value = inputValuesObject.value;

    return {
      ...state,
      commissionInputValues: newState,
    };
  },
  UpdateCommissionCheckboxValue: (state, checked: boolean | undefined) => ({
    ...state,
    commissionCheckboxValue: checked === undefined ? false : checked,
  }),
  AddCommissionProduction: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.commissionProduction];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;
    newState.push({
      productionType: "commission",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId: productionValues.productionId,
    });

    return {
      ...state,
      commissionProduction: newState,
    };
  },
  UpdateCommissionProduction: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.commissionProduction];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    newState[productionValues.idx!] = {
      productionType: "commission",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId:
        state.commissionProduction[productionValues.idx!].productionId,
    };

    return {
      ...state,
      commissionProduction: newState,
    };
  },
  DeleteCommissionProduction: (state, idx: number) => {
    const newState: IInitialProduction[] = [...state.commissionProduction];
    newState.splice(idx, 1);

    return {
      ...state,
      commissionProduction: newState,
    };
  },
  UpdatePremiumInputFieldValues: (state, inputValuesObject: IInputValues) => {
    const newState: IInitialInputValues[] = [...state.premiumInputValues];
    newState[inputValuesObject.idx].value = inputValuesObject.value;

    return {
      ...state,
      premiumInputValues: newState,
    };
  },
  UpdatePremiumCheckboxValue: (state, checked: boolean | undefined) => ({
    ...state,
    premiumCheckboxValue: checked === undefined ? false : checked,
  }),
  AddPremiumProduction: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.premiumProduction];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    newState.push({
      productionType: "premium",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId: productionValues.productionId,
    });

    return {
      ...state,
      premiumProduction: newState,
    };
  },
  UpdatePremiumProduction: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.premiumProduction];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    newState[productionValues.idx!] = {
      productionType: "premium",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId: state.premiumProduction[productionValues.idx!].productionId,
    };

    return {
      ...state,
      premiumProduction: newState,
    };
  },
  DeletePremiumProduction: (state, idx: number) => {
    const newState: IInitialProduction[] = [...state.premiumProduction];
    newState.splice(idx, 1);

    return {
      ...state,
      premiumProduction: newState,
    };
  },
  UpdateIncomeInputFieldValues: (state, inputValuesObject: IInputValues) => {
    const newState: IInitialInputValues[] = [...state.incomeInputValues];
    newState[inputValuesObject.idx].value = inputValuesObject.value;

    return {
      ...state,
      incomeInputValues: newState,
    };
  },
  UpdateIncomeCheckboxValue: (state, checked: boolean | undefined) => ({
    ...state,
    incomeCheckboxValue: checked === undefined ? false : checked,
  }),
  AddIncomeProduction: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.incomeProduction];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = parseIntProductionReducerHelper(productionValues.totalIncome);

    if (state.incomeProduction.length === 0) {
      newState.push({
        productionType: "income",
        riskProtectionProduction: Math.floor(riskProtectionProduction),
        otherNewBusiness: Math.floor(otherNewBusiness),
        totalIncome: Math.floor(total),
        shared: productionValues.shared,
        companyProvided: productionValues.companyProvided,
        productionId: productionValues.productionId,
      });
    }

    return {
      ...state,
      incomeProduction: newState,
    };
  },
  UpdateIncomeProduction: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.incomeProduction];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = parseIntProductionReducerHelper(productionValues.totalIncome);

    newState[productionValues.idx!] = {
      productionType: "income",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      totalIncome: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId: state.incomeProduction[productionValues.idx!].productionId,
    };

    return {
      ...state,
      incomeProduction: newState,
    };
  },
  DeleteIncomeProduction: (state, idx: number) => {
    const newState: IInitialProduction[] = [...state.incomeProduction];
    newState.splice(idx, 1);

    return {
      ...state,
      incomeProduction: newState,
    };
  },
  UpdateCurrency: (state, currency: string) => ({
    ...state,
    selectedCurrency: currency,
  }),
  UpdateCommissionPoliciesCasesInputs: (
    state,
    inputValuesObject: IInputValues
  ) => {
    const newState: IInitialInputValues[] = [
      ...state.commissionPoliciesCasesInputValues,
    ];
    newState[inputValuesObject.idx].value = inputValuesObject.value;

    return {
      ...state,
      commissionPoliciesCasesInputValues: newState,
    };
  },
  UpdateCommissionPoliciesCasesCheckbox: (
    state,
    checked: boolean | undefined
  ) => ({
    ...state,
    commissionPoliciesCasesCheckboxValue:
      checked === undefined ? false : checked,
  }),
  AddCommissionPoliciesCases: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.commissionPoliciesCases];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;
    newState.push({
      productionType: "commission",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId: productionValues.productionId,
    });

    return {
      ...state,
      commissionPoliciesCases: newState,
    };
  },
  UpdateCommissionPoliciesCases: (
    state,
    productionValues: IProductionValues
  ) => {
    const newState: IInitialProduction[] = [...state.commissionPoliciesCases];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    newState[productionValues.idx!] = {
      productionType: "commission",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId:
        state.commissionPoliciesCases[productionValues.idx!].productionId,
    };

    return {
      ...state,
      commissionPoliciesCases: newState,
    };
  },
  DeleteCommissionPoliciesCases: (state, idx: number) => {
    const newState: IInitialProduction[] = [...state.commissionPoliciesCases];
    newState.splice(idx, 1);

    return {
      ...state,
      commissionPoliciesCases: newState,
    };
  },
  UpdatePremiumPoliciesCasesInputs: (
    state,
    inputValuesObject: IInputValues
  ) => {
    const newState: IInitialInputValues[] = [
      ...state.premiumPoliciesCasesInputValues,
    ];
    newState[inputValuesObject.idx].value = inputValuesObject.value;

    return {
      ...state,
      premiumPoliciesCasesInputValues: newState,
    };
  },
  UpdatePremiumPoliciesCasesCheckbox: (
    state,
    checked: boolean | undefined
  ) => ({
    ...state,
    premiumPoliciesCasesCheckboxValue: checked === undefined ? false : checked,
  }),
  AddPremiumPoliciesCases: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.premiumPoliciesCases];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;
    newState.push({
      productionType: "premium",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId: productionValues.productionId,
    });

    return {
      ...state,
      premiumPoliciesCases: newState,
    };
  },
  UpdatePremiumPoliciesCases: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.premiumPoliciesCases];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    newState[productionValues.idx!] = {
      productionType: "premium",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      total: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId:
        state.premiumPoliciesCases[productionValues.idx!].productionId,
    };

    return {
      ...state,
      premiumPoliciesCases: newState,
    };
  },
  DeletePremiumPoliciesCases: (state, idx: number) => {
    const newState: IInitialProduction[] = [...state.premiumPoliciesCases];
    newState.splice(idx, 1);

    return {
      ...state,
      premiumPoliciesCases: newState,
    };
  },
  UpdateIncomePoliciesCasesInputs: (state, inputValuesObject: IInputValues) => {
    const newState: IInitialInputValues[] = [
      ...state.incomePoliciesCasesInputValues,
    ];
    newState[inputValuesObject.idx].value = inputValuesObject.value;

    return {
      ...state,
      incomePoliciesCasesInputValues: newState,
    };
  },
  UpdateIncomePoliciesCasesCheckbox: (state, checked: boolean | undefined) => ({
    ...state,
    incomePoliciesCasesCheckboxValue: checked === undefined ? false : checked,
  }),
  AddIncomePoliciesCases: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.incomePoliciesCases];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    if (state.incomeProduction.length === 0) {
      newState.push({
        productionType: "income",
        riskProtectionProduction: Math.floor(riskProtectionProduction),
        otherNewBusiness: Math.floor(otherNewBusiness),
        totalIncome: Math.floor(total),
        shared: productionValues.shared,
        companyProvided: productionValues.companyProvided,
        productionId: productionValues.productionId,
      });
    }

    return {
      ...state,
      incomePoliciesCases: newState,
    };
  },
  UpdateIncomePoliciesCases: (state, productionValues: IProductionValues) => {
    const newState: IInitialProduction[] = [...state.incomePoliciesCases];
    const riskProtectionProduction = parseIntProductionReducerHelper(
      productionValues.riskProtectionProduction
    );
    const otherNewBusiness = parseIntProductionReducerHelper(
      productionValues.otherNewBusiness
    );
    const total = riskProtectionProduction + otherNewBusiness;

    newState[productionValues.idx!] = {
      productionType: "income",
      riskProtectionProduction: Math.floor(riskProtectionProduction),
      otherNewBusiness: Math.floor(otherNewBusiness),
      totalIncome: Math.floor(total),
      shared: productionValues.shared,
      companyProvided: productionValues.companyProvided,
      productionId:
        state.incomePoliciesCases[productionValues.idx!].productionId,
    };

    return {
      ...state,
      incomePoliciesCases: newState,
    };
  },
  DeleteIncomePoliciesCases: (state, idx: number) => {
    const newState: IInitialProduction[] = [...state.incomePoliciesCases];

    newState.splice(idx, 1);

    return {
      ...state,
      incomePoliciesCases: newState,
    };
  },
  RemoveCompanyAddedProduction: (state) => ({
    ...state,
    commissionProduction: [
      ...state.commissionProduction.filter(
        ({ companyProvided }) => !companyProvided
      ),
    ],
    premiumProduction: [
      ...state.premiumProduction.filter(
        ({ companyProvided }) => !companyProvided
      ),
    ],
    incomeProduction: [
      ...state.incomeProduction.filter(
        ({ companyProvided }) => !companyProvided
      ),
    ],
    commissionPoliciesCases: [
      ...state.commissionPoliciesCases.filter(
        ({ companyProvided }) => !companyProvided
      ),
    ],
    premiumPoliciesCases: [
      ...state.premiumPoliciesCases.filter(
        ({ companyProvided }) => !companyProvided
      ),
    ],
    incomePoliciesCases: [
      ...state.incomePoliciesCases.filter(
        ({ companyProvided }) => !companyProvided
      ),
    ],
  }),
  RemoveUserAddedProduction: (state) => ({
    ...state,
    commissionProduction: [
      ...state.commissionProduction.filter(
        ({ companyProvided }) => companyProvided
      ),
    ],
    premiumProduction: [
      ...state.premiumProduction.filter(
        ({ companyProvided }) => companyProvided
      ),
    ],
    incomeProduction: [
      ...state.incomeProduction.filter(
        ({ companyProvided }) => companyProvided
      ),
    ],
    commissionPoliciesCases: [
      ...state.commissionPoliciesCases.filter(
        ({ companyProvided }) => companyProvided
      ),
    ],
    premiumPoliciesCases: [
      ...state.premiumPoliciesCases.filter(
        ({ companyProvided }) => companyProvided
      ),
    ],
    incomePoliciesCases: [
      ...state.incomePoliciesCases.filter(
        ({ companyProvided }) => companyProvided
      ),
    ],
  }),
});

export default {};
